import { Share2, ShieldCheck } from 'lucide-react';

import {
  type CoverageListItem,
  CoverageSource,
} from '@/services/types/coverage-types';

interface CoverageSharingBannerProps {
  coverage: CoverageListItem;
  /** When true, calls e.stopPropagation() on button clicks (e.g. inside clickable cards) */
  stopPropagation?: boolean;
}

export const CoverageSharingBanner = ({
  coverage,
  stopPropagation = false,
}: CoverageSharingBannerProps) => {
  if (coverage.source === CoverageSource.SHARED) {
    return (
      <div className="flex items-center gap-2 rounded-md border border-indigo-200 bg-indigo-50 px-4 py-2.5 dark:border-indigo-800 dark:bg-indigo-950">
        <ShieldCheck className="h-4 w-4 shrink-0 text-indigo-600 dark:text-indigo-400" />
        <span className="text-xs font-semibold text-indigo-700 dark:text-indigo-300">
          Coverage managed by primary case:
        </span>
        {coverage.primary_matter_id && (
          <a
            href={`/matters/${coverage.primary_matter_id}/coverage`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-semibold text-indigo-600 underline hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-200 transition-colors"
            onClick={(e) => {
              if (stopPropagation) e.stopPropagation();
            }}
          >
            {coverage.primary_matter_name || 'Primary Case'}
          </a>
        )}
      </div>
    );
  }

  if (coverage.source === CoverageSource.OWNED && coverage.shared_to_count > 0) {
    return (
      <div className="flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-4 py-2.5 dark:border-blue-800 dark:bg-blue-950">
        <Share2 className="h-4 w-4 shrink-0 text-blue-600 dark:text-blue-400" />
        <span className="text-xs font-semibold text-blue-700 dark:text-blue-300">
          Coverage shared to companion {coverage.shared_to_count === 1 ? 'case' : 'cases'}:
        </span>
        <span className="text-xs text-blue-600 dark:text-blue-400">
          {coverage.shared_to_matters.map((m, i) => (
            <span key={m.matter_id}>
              {i > 0 && ', '}
              <a
                href={`/matters/${m.matter_id}/coverage`}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold underline hover:text-blue-800 dark:hover:text-blue-200 transition-colors"
                onClick={(e) => {
                  if (stopPropagation) e.stopPropagation();
                }}
              >
                {m.matter_name || 'Companion'}
              </a>
            </span>
          ))}
        </span>
      </div>
    );
  }

  return null;
};
